import { ModernLayout } from './Modern/Modern';
import { ClassicLayout } from './Classic/Classic';

export { ClassicLayout, ModernLayout };